export default __webpack_public_path__ + "static/media/logo_blue.862d7e51.svg";